<template>
    <div :class="['assembled-product-zoom', {'active': isActive}]"
        :style="initialMobileZoomStyle">
        <div class="zoom-trigger" id="zoom-top"
            @mouseenter="onMouseEnter"
            @click="onTouchEndOrClick"
            @touchstart="onTouchStart"
            @touchmove.prevent="onTouchMove"
            @touchend.prevent="onTouchEndOrClick"></div>
        <div class="zoom-trigger" id="zoom-middle"
            @mouseenter="onMouseEnter"
            @click="onTouchEndOrClick"
            @touchstart="onTouchStart"
            @touchmove.prevent="onTouchMove"
            @touchend.prevent="onTouchEndOrClick"></div>
        <div class="zoom-trigger" id="zoom-bottom"
            @mouseenter="onMouseEnter"
            @click="onTouchEndOrClick"
            @touchstart="onTouchStart"
            @touchmove.prevent="onTouchMove"
            @touchend.prevent="onTouchEndOrClick"></div>

        <button class="zoom-close" @click="onClickClose">
            <span class="icon icon-close-thick"></span>
        </button>

        <assembled-product
            :cssClass="assembledProductCssClass"
            :inlineStyle="zoomStyleProps"
            :isVisible="showZoom"
            :isDesktop="isDesktop"
            :isProductZoom="true">
        </assembled-product>

        <div class="zoom-backdrop" v-show="showZoom">
        </div>
    </div>
</template>

<script src="./assembled-product-zoom.js"></script>
